import $ from 'jquery'
import 'slick-carousel'

$(function () {
  const $carousel = $('.carousel-items');

  const getSlidesToShow = () => {
    const w = window.innerWidth;
    if (w < 500) return 1;
    if (w < 800) return 2;
    if (w < 1200) return 4;
    return 6;
  };

  const initialSlidesToShow = getSlidesToShow();

  $carousel.slick({
    arrows: true,
    slidesToScroll: 2,
    slidesToShow: initialSlidesToShow,
    infinite: true,
    variableWidth: false,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  const setTextWidth = () => {
    const imgWidth = $carousel.find('.item-image img').first().innerWidth();
    if (imgWidth) {
      $carousel.find('.item-text').css({ width: imgWidth, height: 'auto' });
    }
  };

  setTextWidth();
  $carousel.on('setPosition', setTextWidth);
});